import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardImageLayout, UitkCardMedia, UitkCardTextSegment } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { LocalizedText } from "bernie-l10n";

export interface TravelersLovedHotelsCardProps {
  hotelCarouselIndex: number;
  hotelName: string;
  endorsedBy: number;
  imageUrl: string;
  hotelInfositeUrl: string;
}

export function TravelersLovedHotelsCard(props: TravelersLovedHotelsCardProps) {
  return (
    <UitkCard
      className="uitk-grid travelersLovedHotelsCard"
      imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}
      withBorder={true}
    >
      <TrackedLink
        data-testid={`travelers-loved-link-${props.hotelCarouselIndex}`}
        className="uitk-card-link"
        moduleName={"travelers-loved-hotels"}
        rfrr={`card-${props.hotelCarouselIndex}`}
        href={props.hotelInfositeUrl}
      />
      <UitkCardMedia className="uitk-cell" pxWidth={120}>
        <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
          <UitkImage src={props.imageUrl} />
        </UitkFigure>
      </UitkCardMedia>
      <UitkCardContent className="uitk-cell">
        <UitkCardTextSegment className="uitk-flex uitk-flex-column uitk-flex-justify-content-space-between">
          <h3 className="uitk-type-heading-300">{props.hotelName}</h3>

          <p>
            <LocalizedText message="hotels.endorsedByTravelers" data={[props.endorsedBy]} />
          </p>
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
}
